import Chartable from "./mixins/chartable";
import DataLabelsPlugin from "chartjs-plugin-datalabels";
import { mixins, Bar } from "vue-chartjs";

export default {
	name: "BarChart",

	extends: Bar,

	mixins: [
		Chartable,
		mixins.reactiveProp
	],

	props: {
		cssClasses: {
			type: String,
			default: "k-chart"
		},
		options: Object
	},

	mounted() {
		this.addPlugin( DataLabelsPlugin );
		this.renderChart( this.chartData, this.options );
	}
};
